<script>
  import LoteDebitoService from '../../../../../domain/leiloes/services/lote-debito'
  import PopupViewer from '../../../../_default/components/popup-viewer/PopupViewer'

  export default {
    name: 'GerenciamentoLoteDebito',
    components: {
      PopupViewer,
      NovoLoteDebito: () => import('./NovoLoteDebito')
    },
    data () {
      return {
        debitos: [],
        debitosLoading: false,
        showDebitoForm: false,
        debitoSendoEditado: null,
        loteDebitoOptions: [
          {label: 'Considerar', value: true, class: 'btn-default'},
          {label: 'Desconsiderar', value: false, class: 'btn-default'}
        ]
      }
    },
    created () {
      this.init()
    },
    mounted () {
      this.carregarDebitosLote()
    },
    filters: {
      upper (str) {
        if (!str) {
          return ''
        }
        return str.toUpperCase()
      }
    },
    methods: {
      init () {
        this.$nextTick(() => {
          let tableDebitosHead = this.$el.querySelector('#tableDebitosHead')
          let tableDebitosBody = this.$el.querySelector('#tableDebitos')
          console.log(tableDebitosBody.clientWidth, tableDebitosHead.clientWidth)
          tableDebitosHead.style.width = tableDebitosBody.clientWidth + 'px'
        })
      },
      carregarDebitosLote () {
        this.debitosLoading = true
        LoteDebitoService.getDebitosLote(this.$route.params.id)
          .then(response => {
            // this.$set(this.lote, 'debitos', response.data)
            this.debitos = response.data
            this.debitosLoading = false
          })
          .catch(error => {
            alert('Erro ao carregar as debitos')
            alert(error.data.errors)
            console.log(error)
            this.debitosLoading = false
          })
      },
      openDebitoForm (evt, id = null) {
        this.debitoSendoEditado = id
        this.showDebitoForm = true
      },
      closeDebitoForm () {
        this.carregarDebitosLote()
        this.showDebitoForm = false
        this.debitoSendoEditado = null
      },
      deletarDebitoLote (evt, id) {
        this.$loaderOverlay.open('Excluindo...')
        LoteDebitoService.deleteDebitoLote(id)
          .then(response => {
            this.$loaderOverlay.hide()
            this.carregarDebitosLote()
          })
          .catch(error => {
            console.log(error)
            alert('Ocorreu um erro ao tentar excluir esse debito')
            this.$loaderOverlay.hide()
          })
      }
    }
  }
</script>

<template>
    <div class="wrapper-sm no-padder m-b">
      <div class=" bg-black">
        <div class="wrapper-sm bg-dark font-bold text-uppercase">
          Débitos <u-button @click.prevent="openDebitoForm" class="btn btn-info btn-xs pull-right m-b" ><i class="fa fa-plus"></i> CADASTRAR NOVO DÉBITO</u-button>
        </div>
        <div class="bg-black pos-rlt" id="tableDebitosHead">
          <table class="table table-black bg-black m-b-none">
            <thead>
            <tr>
              <th style="width: 25%">Descrição</th>
              <th style="width: 10%">Valor</th>
              <th style="width: 10%">Ordem</th>
              <th style="width: 25%">Tipo</th>
              <th style="width: 30%">Opções</th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="scroll-black scroll-lote">
          <table class="table table-black" id="tableDebitos" style="margin-top: -36px">
            <thead>
            <tr>
              <th style="width: 25%">Descrição</th>
              <th style="width: 10%">Valor</th>
              <th style="width: 10%">Ordem</th>
              <th style="width: 25%">Tipo</th>
              <th style="width: 30%">Opções</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(debito, index) in debitos" v-if="!debitosLoading">
              <td>
                <div>{{debito.descricao | upper}}</div>
              </td>
              <td>
                <div>R$ {{debito.valor | moeda}}</div>
              </td>
              <td>
                <div>{{debito.ordem}}</div>
              </td>
              <td>
                <div><div>{{debito.tipo && debito.tipo.nome || '-'}}</div></div>
              </td>
              <td>
                <u-button class="btn btn-xs btn-info pull-none-xs hidden-print  m-l-sm" tabindex="1"
                          @click.prevent="openDebitoForm(null, debito.id)">Editar
                </u-button>
                <u-button class="btn btn-xs btn-danger pull-none-xs hidden-print  m-l-sm" tabindex="1"
                          @click.prevent="deletarDebitoLote(null, debito.id)">Excluir
                </u-button>
              </td>
            </tr>
            <tr v-if="(debitos && !debitos.length) && !debitosLoading">
              <td colspan="5" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhum débito encontrado</span>
              </td>
            </tr>
            <tr v-if="debitosLoading">
              <td colspan="5" class="no-borders text-center" style="border-bottom: none"><i
                class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    <!--<a @click="openDebitoForm" class="btn btn-info m-b">Cadastrar debito</a>-->
    <popup-viewer @close="closeDebitoForm" v-if="showDebitoForm" :title="`Edição de dados de Debito`">
      <NovoLoteDebito @finishSubmit="closeDebitoForm" @cancel="closeDebitoForm" :debitoId="debitoSendoEditado"/>
    </popup-viewer>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// GerenciamentoLoteDebito.vue?b8c9d366